module.exports = __webpack_public_path__ + "assets/img/drumsticks_active.eaf648cf.png";